<template>
  <v-container fluid grid-list-sm>
    <v-layout class="d-flex justify-center">
      <v-flex md6>
        <v-card>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Servicio Social - Descargas</h3>
            </div>
          </v-card-title>
          <v-card-text style="min-height: 200px">
            <div v-if="cargandoDatos">
              <p>Cargando datos</p>
              <v-progress-linear
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </div>
            <div v-if="generandoPdf">
              <v-progress-linear
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </div>
            <v-list two-line>
              <template v-for="item in items">
                <v-list-tile
                  :key="item.id"
                  @click="downloadFile(item)"
                  target="_blank"
                >
                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.documento"></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-icon
                      color="teal"
                    >
                      cloud_download
                    </v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
            <v-alert
              :value="true"
              color="error"
              icon="warning"
              outline
              v-if="items.length === 0 && !cargandoDatos"
            >
              No hay ningún documento disponible.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import fileSaver from 'file-saver'

  export default {
    name: 'ServicioSocialDescargas',
    data: () => ({
      cargandoDatos: false,
      items: [],
      documentExist: false,
      generandoPdf: false
    }),
    computed: {
      ...mapState({
        alumno: state => state.user.profile
      }),
      url () {
        return 'https://sii.tuxtla.tecnm.mx/documentos/servicio_social/index.php?noDeControl=' + this.alumno.noDeControl
        // return 'http://sii.local/documentos/servicio_social/index.php?noDeControl=' + this.alumno.noDeControl
      }
    },
    methods: {
      checkDocumentExist () {
        this.cargandoDatos = true
        axios.get(this.document, { headers: { 'Authorization': '', 'Accept': 'application/pdf' }, responseType: 'arraybuffer' })
          .then(() => {
            this.documentExist = true
          })
          .catch(error => {
            console.log(error.data)
          })
          .finally(() => {
            this.cargandoDatos = false
          })
      },
      getDocumentos () {
        this.cargandoDatos = true
        axios.get(this.url)
          .then(response => {
            this.cargandoDatos = false
            this.items = response.data.data
          })
      },
      downloadFile (item) {
        this.generandoPdf = true
        axios.get(this.url + '&action=download&documentId=' + item.id, { headers: { 'Authorization': '', 'Accept': 'application/pdf' }, responseType: 'arraybuffer' })
          .then(response => {
            this.generandoPdf = false
            const blob = new Blob([response.data], { type: response.headers['content-type'] })
            fileSaver.saveAs(blob, item.documento + '.pdf')
          })
          .catch(error => {
            console.log(error.data)
          })
          .finally(() => {
            this.cargandoDatos = false
          })
      }
    },
    mounted () {
      this.getDocumentos()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/information/ServicioSocialDescargasPage.vue